const memberAnalyse = () => import('@/view/memberAnalyse')
const portrayal = () => import('@/view/memberAnalyse/portrayal.vue')
const AARR = () => import('@/view/memberAnalyse/AARR.vue')
const lifecycle = () => import('@/view/memberAnalyse/lifecycle.vue')
const OfficialAccounts = () => import('@/view/memberAnalyse/OfficialAccounts.vue')
const fansChange = () => import('@/view/memberAnalyse/fansChange.vue')
const fansAnalyse = () => import('@/view/memberAnalyse/fansAnalyse.vue')
const memberEvent = () => import('@/view/memberAnalyse/memberEvent.vue')
const eventDetails = () => import('@/view/memberAnalyse/eventDetails.vue')

let router = [
    {
        path: '/memberAnalyse',
        component: memberAnalyse,
        name: 'memberAnalyse',
        redirect: '/memberAnalyse/portrayal',
        meta: {
            menuTitle: "会员分析",
            menuKey: 'memberAnalyse',
            menuIcon: 'icon-analys',
        },
        children: [
            {
                path: 'memberPortrayal',
                component: memberAnalyse,
                name: 'memberPortrayal',
                redirect: '/memberAnalyse/portrayal',
                meta: {
                    menuKey: "memberAnalyse",
                    menuTitle: "会员画像",
                    menuIcon: "icon-member-portrait1",
                },
                children: [
                    {
                        path: '/memberAnalyse/portrayal',
                        component: portrayal,
                        name: 'portrayal',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "会员画像",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    },
                    {
                        path: '/memberAnalyse/AARR',
                        component: AARR,
                        name: 'AARR',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "AARR分析",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    }
                ]
            },
            {
                path: 'memberPortrayal',
                component: memberAnalyse,
                name: 'memberPortrayal',
                meta: {
                    menuKey: "memberAnalyse",
                    menuTitle: "ltv分析",
                    menuIcon: "icon-ltv-analyse",
                },
                children: [
                    {
                        path: '/memberAnalyse/lifecycle',
                        component: lifecycle,
                        name: 'lifecycle',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "会员生命周期",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    }
                ]
            },
            {
                path: 'memberPortrayal',
                component: memberAnalyse,
                name: 'memberPortrayal',
                meta: {
                    menuKey: "memberAnalyse",
                    menuTitle: "微信生态分析",
                    menuIcon: "icon-wx-analyse",
                },
                children: [
                    {
                        path: '/memberAnalyse/OfficialAccounts',
                        component: OfficialAccounts,
                        name: 'OfficialAccounts',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "公众号分析",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    },
                    {
                        path: '/memberAnalyse/fansChange',
                        component: fansChange,
                        name: 'fansChange',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "粉丝转化",
                            menuIcon: "el-icon-chat-dot-round",
                        },
                    },
                    {
                        path: '/memberAnalyse/fansAnalyse',
                        component: fansAnalyse,
                        name: 'fansAnalyse',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "粉丝分析",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    }
                ]
            },
            {
                path: 'memberPortrayal',
                component: memberAnalyse,
                name: 'memberPortrayal',
                meta: {
                    menuKey: "memberAnalyse",
                    menuTitle: "数字化事件",
                    menuIcon: "icon-num-event",
                },
                children: [
                    {
                        path: '/memberAnalyse/memberEvent',
                        component: memberEvent,
                        name: 'memberEvent',
                        meta: {
                            menuKey: "memberAnalyse",
                            menuTitle: "会员事件",
                            menuIcon: "el-icon-monitor",
                        },
                    },
                    {
                        path: '/memberAnalyse/memberEvent/details',
                        component: eventDetails,
                        name: 'memberEvent_details',
                        meta:{
                            menuKey: "memberAnalyse",
                            secondMenuKey: 'memberEvent'
                        }
                    }
                ]
            }
        ]
    }
]
export default router